import React from 'react';
import T from 'i18n-react';
import { camelCase, curry } from 'lodash';

import { LabelContainer } from '@motorway/motorway-storybook-cra';

import CheckboxGroup from 'Components/shared/CheckBoxGroup/CheckboxGroup';
import stylesFilter from 'Components/VehicleList/filters/Filters.module.scss';
import { VEHICLE_CLASSES } from 'Components/VehicleList/VehicleListFilters.consts';
import { triggerVehicleClassSelectedEvent } from 'Services/analytics/events';
import useVehicleFilterStore from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';

import { getVehicleClassKey } from '../Filters.helpers';

T.setTexts(require('Components/texts.json'));

const VehicleClass = () => {
	const checkboxOptions = (options, key) =>
		options.map((value) => ({
			label: T.translate(`vehicleList.filters.${key}.${camelCase(value)}`),
			value,
		}));

	const { vehicleClass } = useVehicleFilterStore((store) => store.filters);
	const setValue = useVehicleFilterStore((store) => store.setValue);

	const isAllSelected = (clickedOption, value, currentlySelected) =>
		clickedOption === VEHICLE_CLASSES.ALL && !currentlySelected.length && !value;

	const handleOnClick = curry((section, clickedOption, value, currentlySelected) => {
		setValue({ id: section, value: [...currentlySelected] });

		if (isAllSelected(clickedOption, value, currentlySelected)) {
			return;
		}

		const vehicleClassKey = getVehicleClassKey(clickedOption);

		triggerVehicleClassSelectedEvent({ isSelected: value, vehicleClassKey });
	});

	return (
		<div className={stylesFilter.vehicleClass}>
			<LabelContainer className="mw-mb-1" label={T.translate('vehicleList.filters.vehicleClass.label')} />
			<CheckboxGroup
				checked={[...vehicleClass]}
				columns={3}
				id="vehicleClass"
				name="vehicleClass"
				onClick={handleOnClick('vehicleClass')}
				options={checkboxOptions(Object.values(VEHICLE_CLASSES), 'vehicleClass')}
			/>
		</div>
	);
};

export default VehicleClass;
